var _mask, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_14656_24291",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 44,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 42,
    height: 44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 21C1 9.95754 9.95169 1 20.9942 1C32.0366 1 40.9883 9.95754 40.9883 21C40.9883 32.0425 32.0366 41 20.9942 41C9.95169 41 1 32.0425 1 21Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.166667 20.9942C0.166667 9.49145 9.49145 0.166667 20.9942 0.166667C32.4969 0.166667 41.8216 9.49145 41.8216 20.9942H40.155C40.155 10.4119 31.5764 1.83333 20.9942 1.83333C10.4119 1.83333 1.83333 10.4119 1.83333 20.9942H0.166667ZM41.8216 22.6725C41.8216 34.1752 32.4969 43.5 20.9942 43.5C9.49145 43.5 0.166667 34.1752 0.166667 22.6725L1.83333 21.0058C1.83333 30.6676 10.4119 38.5 20.9942 38.5C31.5764 38.5 40.155 30.6676 40.155 21.0058L41.8216 22.6725ZM20.9942 43.5C9.49145 43.5 0.166667 34.1752 0.166667 22.6725V20.9942C0.166667 9.49145 9.49145 0.166667 20.9942 0.166667V1.83333C10.4119 1.83333 1.83333 10.4119 1.83333 20.9942V21.0058C1.83333 30.6676 10.4119 38.5 20.9942 38.5V43.5ZM20.9942 0.166667C32.4969 0.166667 41.8216 9.49145 41.8216 20.9942V22.6725C41.8216 34.1752 32.4969 43.5 20.9942 43.5V38.5C31.5764 38.5 40.155 30.6676 40.155 21.0058V20.9942C40.155 10.4119 31.5764 1.83333 20.9942 1.83333V0.166667Z",
    fill: "#90A8C1",
    fillOpacity: 0.3,
    mask: "url(#path-1-outside-1_14656_24291)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0397 1H20.9486C9.93131 1 1 9.93391 1 20.9545V21.0455C1 32.0661 9.93131 41 20.9486 41H21.0397C32.057 41 40.9883 32.0661 40.9883 21.0455V20.9545C40.9883 9.93391 32.057 1 21.0397 1Z",
    fill: "url(#paint0_linear_14656_24291)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1783 9.14062H14.8048C11.3864 9.14062 8.60547 11.9224 8.60547 15.3418V26.6651C8.60547 30.0845 11.3864 32.8662 14.8048 32.8662H27.1783C30.5967 32.8662 33.3777 30.0845 33.3777 26.6651V15.3418C33.3777 11.9224 30.5967 9.14062 27.1783 9.14062ZM10.7924 15.3418C10.7924 13.129 12.5927 11.3282 14.8048 11.3282H27.1783C29.3905 11.3282 31.1907 13.129 31.1907 15.3418V26.6651C31.1907 28.8779 29.3905 30.6787 27.1783 30.6787H14.8048C12.5927 30.6787 10.7924 28.8779 10.7924 26.6651V15.3418Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.993 26.7707C24.1719 26.7707 26.7595 24.1837 26.7595 21.0025C26.7595 17.8213 24.1733 15.2344 20.993 15.2344C17.8128 15.2344 15.2266 17.8213 15.2266 21.0025C15.2266 24.1837 17.8128 26.7707 20.993 26.7707ZM20.993 17.4234C22.967 17.4234 24.5725 19.0294 24.5725 21.0039C24.5725 22.9785 22.967 24.5845 20.993 24.5845C19.019 24.5845 17.4135 22.9785 17.4135 21.0039C17.4135 19.0294 19.019 17.4234 20.993 17.4234Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2924 16.1639C28.1487 16.1639 28.8466 15.4672 28.8466 14.6093C28.8466 13.7514 28.1501 13.0547 27.2924 13.0547C26.4348 13.0547 25.7383 13.7514 25.7383 14.6093C25.7383 15.4672 26.4348 16.1639 27.2924 16.1639Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14656_24291",
    x1: 6.84211,
    y1: 35.1562,
    x2: 35.1545,
    y2: 6.85349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DD2A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#9537B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515BD4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareInstagram);
export default __webpack_public_path__ + "static/media/ShareInstagram.1be2ed6eb6f63c1b466d7fc257c56f5e.svg";
export { ForwardRef as ReactComponent };